import React from "react";
import About from "../about/About";
import "./pages.css";

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <About />
    </div>
  );
};

export default AboutUs;
